import type { ButtonHTMLAttributes, ReactNode } from 'react';

export type ButtonVariant = 'primary' | 'secondary' | 'ghost' | 'danger';

export interface ButtonProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  variant?: ButtonVariant;
  fullWidth?: boolean;
  loading?: boolean;
  children: ReactNode;
}

/**
 * Ein Button im Ladezustand bleibt im DOM erhalten und wechselt nur seinen
 * Text — ein Austausch gegen einen Spinner wuerde den Fokus verlieren und
 * Screenreader aus dem Kontext werfen. aria-busy meldet den Zustand.
 */
export function Button({
  variant = 'primary',
  fullWidth = false,
  loading = false,
  disabled,
  children,
  type = 'button',
  ...rest
}: ButtonProps) {
  return (
    <button
      {...rest}
      type={type}
      className={`btn ${rest.className ?? ''}`.trim()}
      data-variant={variant}
      data-full={fullWidth}
      disabled={disabled || loading}
      aria-busy={loading}
    >
      {children}
    </button>
  );
}
